'use strict';
import isFunction from 'lodash/isFunction';
import * as T from 'prop-types';
import React, {Component} from 'react';
import 'rxjs/add/operator/delay';
import {IonicModal} from '../../../react-modals/IonicModal';
import {ModalHOC} from '../../../react-modals/ModalContainer';
import {epicErrorHandler} from '../../../rx-utils';


/**
 * @typedef {Object} ReactReduxModalHOCOptions
 * @property {Function} getState
 * @property {Logger} logger
 * @property {ReactReduxModalActions} actions
 */

/**
 * @param WrappedComponent
 * @param {ReactReduxModalHOCOptions} options
 * @param [ModalWrapper=IonicModal]
 * @return {*}
 * @constructor
 */
export function ReactReduxModalHOC(WrappedComponent, options, ModalWrapper = IonicModal) {
  /** @type {ReactReduxModalActions} */
  const actions = options.actions;
  const logger = options.logger;

  if (!actions)
    throw new Error('ReactReduxModalHOC missing required actions');

  if (!logger)
    throw new Error('ReactReduxModalHOC missing required logger');

  class ReactReduxModalHOCComponent extends Component {
    static propTypes = {
      // modal actions
      onSuccess: T.func/* .isRequired*/,
      onCancel: T.func/* .isRequired*/,
      onSubmit: T.func,
    };

    static defaultProps = {};

    constructor(props) {
      super(props);
      this.state = {
        ...options.getState(ReactReduxModalHOC.dependencies.$ngRedux.getState()),
      };

      this.handleClose = this.handleClose.bind(this);
    }

    handleClose(e) {
      e.preventDefault();
      e.stopPropagation();
      if (isFunction(this.props.onCancel)) {
        this.props.onCancel();
      }
    }

    componentDidMount() {
      this.updateSubscription = ReactReduxModalHOC.dependencies.$ngRedux.state$
        .map(options.getState)
        .distinctUntilChanged()
        .catch(epicErrorHandler(logger, 'ReactReduxModalHOC.state$'))
        .delay(0)
        .subscribe(nextState => {
          if (!nextState.isShowingModal && isFunction(this.props.onSuccess)) {
            this.props.onSuccess();
          }
          this.setState(nextState);
        });
    }

    componentWillUnmount() {
      this.updateSubscription && this.updateSubscription.unsubscribe();
      ReactReduxModalHOCComponent.hide();
    }

    render() {
      return (
        <WrappedComponent
          className={this.props.className}
          onClose={this.handleClose}
          onSuccess={this.props.onSuccess}
          onCancel={this.props.onCancel}
          onSubmit={this.props.onSubmit}
          actions={actions}

          {...this.state}
        />
      );
    }

    static hide() {
      ReactReduxModalHOC.dependencies.$ngRedux.dispatch(actions.hideModal());
    }
  }

  return ModalHOC(ModalWrapper, ReactReduxModalHOCComponent);
}

ReactReduxModalHOC.$inject = [
  '$ngRedux',
];




// WEBPACK FOOTER //
// ./src/js/core-utilities/react-redux-modals/components/ReactReduxModalHOC/ReactReduxModalHOC.js